<template>
	<div class="project-row" v-if="!sidebarMini && selectedProject">
		<img v-if="selectedProject.project_image" :src="selectedProject.project_image" class="project-avatar-sm"/>
		<v-icon v-else small color="#2D4B95">mdi-office-building-outline</v-icon>
		<p class="mb-0 project-name">{{ selectedProject.name }}</p>
		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
			<v-btn icon x-small color="#5E85EF" dark depressed class="swap-btn" v-bind="attrs" v-on="on">
				<v-icon small>mdi-swap-horizontal</v-icon>
				</v-btn>
			</template>
			<v-list dense class="py-0 white" max-height="350">
				<v-list-item dense class="mb-1" style="min-height: 25px; background: #5E85EF;">
					<p class="caption mb-0 font-weight-bold white--text">Cambiar de Proyecto</p>
				</v-list-item>
				<v-list-item-group color="#5E85EF" class="white">
					<v-list-item
						v-for="(project, index) in projectsList"
						v-show="selectedProject && selectedProject.id != project.id"
						:key="index" dense @click="changeProject(project)">
						<v-list-item-title dense>{{ project.name }}</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'ProjectSelector',
	computed: {
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		sidebarMini() {
			return this.$store.menuStore.state.sidebarMini
		},
		projectsList() {
			return this.$store.projectsStore.state.projectsList
		}
	},
	methods:{
		async changeProject(project){
			const projectID = project.id
			const companyID = project.company_id
			this.$store.userStore.commit('setCompanyPermissions', null)
			const loaded = await this.$store.projectsStore.dispatch('getSelectedProject', projectID)
			if(!loaded) return
			if(this.$store.userStore.state.userCompanies.length > 0){
				const found = this.$store.userStore.state.userCompanies.find((company) => {
					return company.company_id === companyID
				})
				if(found){
					this.$store.userStore.commit('setCompanyPermissions', found.capabilities)
					this.$store.userStore.commit('setSelectedCompany', found)
					this.$store.userStore.commit('setSelectedCompanyMembership', found)
				}
			}
			if(projectID){
				this.$store.consultasStore.dispatch('getTaskCodes', {project_id: projectID})
				this.$store.consultasStore.dispatch('getMyTasks', {project_id: projectID})
				this.$store.rdiStore.dispatch('getRDI', {project_id: projectID})
			}
			this.$store.projectsStore.dispatch('getDashboardInfo')
			this.$store.fileManagerStore.dispatch('getProjectStorageSize', { project_id: projectID })
			this.getProjectUserList(projectID)
		},
		getProjectUserList(projectID){
			const data = {
				project_id: projectID,
				start: 0,
				limit: 20
			}
			this.$store.usersStore.dispatch('getUsersList', data)
		},
	}
}
</script>

<style>
	.project-row {
		display: flex;
		align-items: center;
		gap: 6px;
		background: #eef1fb;
		border-radius: 8px;
		padding: 5px 8px;
		border: 1px solid #d8e0f5;
	}

	.swap-btn {
		border-radius: 6px !important;
		text-transform: none !important;
		letter-spacing: 0 !important;
		font-size: 10px !important;
		height: 20px !important;
		padding: 0 5px !important;
		margin-left: auto;
		flex-shrink: 0;
	}

	.project-avatar-sm {
		width: 22px;
		height: 22px;
		border-radius: 50%;
		object-fit: cover;
		flex-shrink: 0;
	}

	.project-name {
		font-size: 11px;
		font-weight: 600;
		color: #2D4B95;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
		min-width: 0;
	}
</style>